// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.DefaultKPIConfiguration.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------
import DefaultKPIPropsDefinedSchema from './Izenda.DefaultKPIPropsDefinedSchema';
import DefaultKPIPropsMappingProps from './Izenda.DefaultKPIPropsMappingProps';
import DefaultKPIPropsMappingSource from './Izenda.DefaultKPIPropsMappingSource';
import DefaultKPIPropsWidget from './Izenda.DefaultKPIPropsWidget';
import DefaultKPIPropsOnChangeValue from './Izenda.DefaultKPIPropsOnChangeValue';
import ReportPartKPIContent from 'logic/models/ReportPartKPIModels/Izenda.ReportPartKPIContent';

import { Highcharts } from 'share/components/charting/highcharts/Izenda.HighchartsVizNames.js';
import { REPORT_PART_TYPE } from 'logic/data/Izenda.ReportDesignerConstants';
import { COMMON_OPTIONS, THRESHOLDS_LINE, AXIS_OPTIONS } from '../ReportPartChart/Izenda.DefaultChartOptionsMappings';
import { constant } from 'lodash/fp';

import cfgFactories from 'share/factories/Izenda.ReportPartConfigurationFactories';

/** Default chart configuration */
cfgFactories.setConfiguration(REPORT_PART_TYPE.KPI, {
  /**
   * Visualization engine name
   */
  visualEngine: Highcharts,

  /**
   * Label of visualization, normally showing in chart type dropdown
   */
  visualLabel: null,

  /**
   * A CSS class to show preview image of the visualization, normally showing when hovering a chart dropdown item
   */
  visualPreviewCSS: null,

  /**
   * Type of visualization, e.g. chart type in Highcharts
   */
  visualType: null,

  /**
   * Report part content model class
   */
  model: ReportPartKPIContent,

  /**
   * The array function to create chart back-side fields containers.
   */
  fieldContainerSchema: [
    constant({
      chart_title: true
    })
  ],

  /**
   * The object contains the property editor widget component
   */
  propertyWidgets: DefaultKPIPropsWidget,

  /**
   * The object contains defined schema of property editor GUI
   */
  propertySchema: DefaultKPIPropsDefinedSchema, // properties ui for x and y axis fields and report

  /**
   * The function to create the mapping properties
   */
  propertyMappingProps: DefaultKPIPropsMappingProps,

  /**
   * The function to create the mapping source
   */
  propertyMappingSource: DefaultKPIPropsMappingSource,

  /**
   * The function to create an value changed handler
   */
  propertyValueChange: DefaultKPIPropsOnChangeValue,

  optionsMapping: {
    /**
     * The object containts common options mapping
     */
    commonOptions: COMMON_OPTIONS,

    /**
     * The object contains options by type mapping
     */
    optionsByType: {},

    /**
     * The object contains the threshold options mapping
     */
    thresholdOptions: THRESHOLDS_LINE,

    /**
     * The object contains the axis options mapping
     */
    axisOptions: AXIS_OPTIONS
  }
});



// WEBPACK FOOTER //
// ./ui/modules/ReportDesigner/Fields/ReportBody/ReportPartType/ReportPartKPI/Izenda.DefaultKPIConfiguration.js